import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/*
 * useBackTo — browser ke BACK button ko ek tay jagah pe mod deta hai.
 *
 * KYUN CHAHIYE: onboarding ki kuch screens pe "peeche" jaana nuksaan karta hai
 * — number assign ho chuka hota hai, payment ho chuka hota hai, ya peeche
 * checkout/Stripe ka page hota hai. Back dabane par user ko wahan nahi, ek
 * safe jagah pe le jaana hai.
 *c
 * KAISE: sirf popstate PUSHcxcx kar navigate karna KAAM NAHI KARTA — back dabte hi
 * React Router apna handler pehle chala kar route badal deta hai aur hamara
 * navigate race me haar jaata hai. Isliye ek DUPLICATE history entry
 * ("sentinel") push karte hain: back use khaata hai, URL nahi badalta, Router
 * ko koi changevvvvv dikhta hi nahi, aur phir hum aaram se navigate kar dete hain.
 *
 * SENTINEL EK BAAR, PER MOUNT — ref se guard kiya hua.
 *
 * Do galtiyan yahan aasani se ho jaati hain, dono se back "mar" jaata hai:
 *
 *  1. Har effect-run pe push karna. Effect deps (navigate/to) badalne par ya
 *     dev StrictMode ke double-mount par entries jama hoti rehti hain; phir back
 *     unhe ek-ek karke khaata hai aur user ko lagta hai kuch ho hi nahi raha.
 *
 *  2. Pop ke andar dobara push karna aur turant replace karna. Wo push+replace
 *     ka jodaa history ko aisi haalat me chhod deta hai jahan back inert lagta
 *     hai.
 *
 * Isliye: mount pe THEEK EK sentinel, aur pop par sirf navigate. Navigate route
 * hi badal deta hai, to component unmount ho jaata hai aur dobara arm karne ki
 * zarurat hi nahi rehti.
 *
 * @param {string} to        kahan bhejna hai (app ka internal path)
 * @param {boolean} enabled  false ho to hook kuch nahi karta (variant gating)
 */
export default function useBackTo(to, enabled = true) {
    const navigate = useNavigate();
    const armedRef = useRef(false);

    useEffect(() => {
        if (!enabled || !to) return undefined;

        if (!armedRef.current) {
            window.history.pushState(null, "", window.location.href);
            armedRef.current = true;
        }

        const onPop = () => {
            armedRef.current = false; // sentinel kha liya gaya
            navigate(to, { replace: true });
        };

        window.addEventListener("popstate", onPop);
        return () => window.removeEventListener("popstate", onPop);
    }, [to, enabled, navigate]);
}
